import { render } from "./Customer.vue?vue&type=template&id=7a95c666&scoped=true"
import script from "./Customer.vue?vue&type=script&lang=js"
export * from "./Customer.vue?vue&type=script&lang=js"

import "ag-grid-community/dist/styles/ag-theme-alpine.css?vue&type=style&index=0&lang=css"
import "ag-grid-community/dist/styles/ag-grid.css?vue&type=style&index=1&lang=css"
import "./Customer.vue?vue&type=style&index=2&id=7a95c666&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2433923721/src/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a95c666"]])

export default __exports__